<template>
    <div class="modal expiring-modal">
        <div class="modal-heading">
            <h2><span class="warning"></span>Keep your numbers</h2>
        </div>
        <div class="modal-content">
            <p>As your basket has been inactive for 25 minutes, your number selection will expire shortly.</p>
            <p>Please progress with your purchase now in order to keep your reserved numbers.</p>
        </div>
        <button class="" @click="ok">Continue</button>
    </div>
</template>
<script>
export default {
    created() {
        
    },
    methods: {
        ok() {
            this.$emit('close', { item: this.item });
        }
    }
}
</script>